import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

export class AddScheduledEventLocationComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            renderModal: false
        };
    }

    render() {
        const { renderModal, showModal } = this.state;

        return (
            <>
                <input
                    onClick={() =>
                        this.setState({
                            showModal: true,
                            renderModal: true
                        })
                    }
                    className="btn btn-primary"
                    value="Add Location"
                    type="button"
                />
                {renderModal && (
                    <AddScheduledEventLocationModalComponent
                        userId={this.props.userId}
                        showModal={showModal}
                        handleClose={() => {
                            this.setState({ showModal: false });
                        }}
                        onLocationAddComplete={this.props.onLocationAddComplete}
                        onExited={() => {
                            this.setState({ renderModal: false });
                        }}
                    />
                )}
            </>
        );
    }
}

class AddScheduledEventLocationModalComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            UserId: props.userId,
            Name: "",
            Address1: "",
            Address2: "",
            City: "",
            State: "",
            Zip: "",
            Directions: "",
            ClrTimeZoneId: "",
            timeZones: [
                { value: "Hawaiian Standard Time", label: "(UTC-10:00) Hawaii" },
                { value: "Alaskan Standard Time", label: "(UTC-09:00) Alaska" },
                { value: "Pacific Standard Time", label: "(UTC-08:00) Pacific Time (US & Canada)" },
                { value: "US Mountain Standard Time", label: "(UTC-07:00) Arizona" },
                { value: "Mountain Standard Time", label: "(UTC-07:00) Mountain Time (US & Canada)" },
                { value: "Central Standard Time", label: "(UTC-06:00) Central Time (US & Canada)" },
                { value: "Eastern Standard Time", label: "(UTC-05:00) Eastern Time (US & Canada)" }
            ],
            errors: null,
            isSaving: false
        };
    }

    handleInputChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    save = () => {
        this.setState(
            {
                isSaving: true,
                errors: null
            },
            () => {
                fetch(`/api/events/locations/create`, {
                    method: "POST",
                    body: JSON.stringify(this.state),
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                    .then((req) => req.json())
                    .then((resp) => {
                        if (resp.success) {
                            if (this.props.onLocationAddComplete) {
                                this.props.onLocationAddComplete(resp.id, this.state);
                            }
                            if (this.props.onExited) {
                                this.props.onExited();
                            }
                        } else {
                            const errors = resp.errors?.detail
                                ? [resp.errors.detail]
                                : ["A general error occurred. Please contact your system administrator."];
                            this.setState({
                                errors,
                                isSaving: false
                            });
                        }
                    });
            }
        );
    };

    render() {
        const { showModal, handleClose, onExited } = this.props;
        const {
            Name,
            Address1,
            Address2,
            City,
            State,
            Zip,
            Directions,
            ClrTimeZoneId,
            timeZones,
            errors,
            isSaving
        } = this.state;

        return (
            <Modal isOpen={showModal} onClosed={onExited}>
                <ModalHeader toggle={handleClose}>Add Event Location</ModalHeader>
                <ModalBody>
                    <div className="form-row">
                        <div className="form-group col-12">
                            <label htmlFor="Name">Name</label>
                            <input
                                type="text"
                                id="Name"
                                name="Name"
                                value={Name}
                                onChange={this.handleInputChange}
                                placeholder="Enter Location Name"
                                className="form-control"
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-12">
                            <label htmlFor="Address1">Address 1</label>
                            <input
                                type="text"
                                id="Address1"
                                name="Address1"
                                value={Address1}
                                onChange={this.handleInputChange}
                                placeholder="Address 1"
                                className="form-control"
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-12">
                            <label htmlFor="Address2">Address 2</label>
                            <input
                                type="text"
                                id="Address2"
                                name="Address2"
                                value={Address2}
                                onChange={this.handleInputChange}
                                placeholder="Address 2"
                                className="form-control"
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-6">
                            <label htmlFor="City">City</label>
                            <input
                                type="text"
                                id="City"
                                name="City"
                                value={City}
                                onChange={this.handleInputChange}
                                placeholder="City"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group col-3">
                            <label htmlFor="State">State</label>
                            <input
                                type="text"
                                id="State"
                                name="State"
                                value={State}
                                onChange={this.handleInputChange}
                                placeholder="State"
                                className="form-control"
                                maxLength="2"
                            />
                        </div>
                        <div className="form-group col-3">
                            <label htmlFor="Zip">Zip</label>
                            <input
                                type="text"
                                id="Zip"
                                name="Zip"
                                value={Zip}
                                onChange={this.handleInputChange}
                                placeholder="Zip"
                                className="form-control"
                                maxLength="5"
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-12">
                            <label htmlFor="ClrTimeZoneId">Event Time Zone</label>
                            <select
                                id="ClrTimeZoneId"
                                name="ClrTimeZoneId"
                                value={ClrTimeZoneId}
                                onChange={this.handleInputChange}
                                className="form-control"
                            >
                                <option value="">Select a Time Zone</option>
                                {timeZones.map((tz) => (
                                    <option key={tz.value} value={tz.value}>
                                        {tz.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-12">
                            <label htmlFor="Directions">Directions</label>
                            <textarea
                                id="Directions"
                                name="Directions"
                                value={Directions}
                                onChange={this.handleInputChange}
                                placeholder="Directions"
                                className="form-control"
                                rows={5}
                            ></textarea>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {errors && (
                        <div className="text-danger text-left">
                            {errors.map((error, idx) => (
                                <div key={idx}>{error}</div>
                            ))}
                        </div>
                    )}
                    <Button onClick={this.save} disabled={isSaving}>
                        {isSaving ? "Saving..." : "Create"}
                    </Button>
                    <Button onClick={handleClose} disabled={isSaving}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}
